const DentistActionTypes = {
    SEARCH_LABS: 'SEARCH_LABS',
    SEARCH_LABS_SUCCESS: 'SEARCH_LABS_SUCCESS',
};

export default DentistActionTypes;
